import React from 'react'
import './drop-down-card.css'
import trachCan from '../../img/delete.svg'
import pencil from '../../img/pencil.svg'

const DropDownCard = (props) => {
    if(!props.create){
        return(
            <div className="drop-down-card">
                <p className="drop-down-title" onClick={() => props.openANewWorkflow(props.todoId)}>{props.name}</p>
                <img className="drop-down-trashcan" alt="trashcan" onClick={() => props.setAreYouSure(props.todoId)} src={trachCan} />
                <img className="drop-down-trashcan" alt="trashcan" onClick={() => props.setEditWorkflow(props.todoId)} src={pencil} />
            </div>
        )
    } else {
        return(
            <div className="drop-down-card" onClick={() => props.openTemplate()}>
                <p className="drop-down-title" style={{color: "green"}}>{props.name}</p>
            </div>
        )
    }
}
export default DropDownCard;